import { render } from "./ImageDialog.vue?vue&type=template&id=0dccf696&scoped=true"
import script from "./ImageDialog.vue?vue&type=script&lang=js"
export * from "./ImageDialog.vue?vue&type=script&lang=js"

import "./ImageDialog.vue?vue&type=style&index=0&id=0dccf696&scoped=true&lang=css"

import exportComponent from "C:\\Users\\aurel\\Desktop\\new-website\\portfolio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dccf696"]])

export default __exports__